export const fetchFoldersJsonData = async (accessToken) => {
    const requestURL = encodeURI(
      `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/app-files/folders?getAll=true`
    );
    const headers = new Headers({ Authorization: `Bearer ${accessToken}` });
    try {
      const data = await fetch(requestURL, { method: 'GET', headers });
      if (!data.ok) {
        const message = `${data.status} - Fetch Folders Json Failed`;
        const errorType = 'fetchFoldersJson';
        const errorCode = data.status;
        return [];
      }
      const jsonData = await data.json();
      return jsonData || [];
    } catch (error) {
      return [];
    }
  };
